import * as THREE from "three";

export default class ModelManager {
    constructor() {
    }
}